import { AdminAppState, Page } from '../../state';
import { getPage } from './get-page';

export const getPageTags = (pageKey: string) => (
  state: AdminAppState,
): Page['tags'] => getPage(pageKey)(state).tags;
